export default {
  //Danmark / Dansk da DK
LandingPage: {
  intro_sub:
    'Giv emballagen nyt liv',
  title: 'Samsungs emballager',
  sequence1_1: 'Find nye ting at bruge emballagen til',
  sequence1_2:
    "Lav nye produkter ud af dit TV's emballage. Se herunder, hvordan du gør.",
  sequence2_1: 'Vi vil gerne præsentere: Samsungs nye emballager',
  sequence2_2:
    'TV-emballager, der er beregnet til at blive "upcycled", dvs. til, at man laver nye produkter ud af emballagen.',
  sequence3_1: 'Følg vejledningen på emballagen',
  sequence3_2:
    'Klip emballagen ud som vist i instruktionerne, og sæt delene sammen til et nyt produkt!',
  sequence4_1: 'Vælg, hvilket produkt du vil lave',
  sequence4_2:
    'Herunder skal du vælge den TV-model, du har. Derefter skal du vælge mellem de forskellige ting, du kan lave, og begynde at fremstille det ud af emballagen.',
  selectBox: 'Vælg dit TV',
  moreActivity:
    "Flere informationer om Samsungs aktiviteter",
  OLED: 'OLED', 
  QLED8K: 'QLED', //update
  UHD: 'Crstal UHD', //update
  theFrame: 'The Frame', //update
  theSerif: 'The Serif', //update
  theSero: 'The Sero', //update
  theTerrace: 'The Terrace', //update
  thePremiere: 'The Premiere', //update
  Monitors: 'Monitors', //update
  OdysseyArk:"Odyssey Ark",
  QSoundbar: 'Q Soundbar', //update
  Soundbar: 'Soundbar', //update
  SoundbarSet01:'Soundbar Set 2',
  SoundbarSet02:'Soundbar Set 1',
  TheTerraceSoundbar:'The Terrace Soundbar',
  Soundtower:'Sound Tower',
  BespokeJet: 'BESPOKE Jet\n (Jet)',
  BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
  BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
  BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
  BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
  BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
  BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
  BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
  Qooker:'Qooker',
  BespokeSlim:'BESPOKE Slim',
  TheFreeStyle:"The Freestyle",
  BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
  JetCleanStation:"Jet&\nClean Station™",
  JetCleanStation2:"Jet&Clean Station™",
  Bluesky:"BlueSky \n5500",
  BlueSky3000:"BlueSky \n3000",
  BlueSky3100:"BlueSky \n3100",
  BlueSky5000:"BlueSky \n5000",
  BespokeJetbot:"BESPOKE\n Jet Bot",
  BespokeJetbot2:"BESPOKE Jet Bot",
  BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
  BespokeJetbotPlus2:"BESPOKE Jet Bot+",
  BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
  BespokeJetbotAI2:"BESPOKE Jet Bot AI",
  Canister01:"Canister \n01",
  Canister02:"Canister \n02",
  Jupiter:"Vacuum \nCleaner",
  ref_cube:"BESPOKE Cube",
  WaterPurifier:"Water Purifier",
  LATIN:"LATIN",
  LATIN10:"LATIN10",
  MIRROR:"MIRROR",
  MW5100J:"MW5100J",
  STENA:"STENA",
  // moreActivityLink:
  //   'https://www.samsung.com/us/sustainability/overview/',
  moreActivityLink:'https://www.samsung.com/dk/aboutsamsung/sustainability/strategy/',
  footer: `
  Copyright© 2019-2021 Samsung. Alle rettigheder forbeholdes.`,
},
ProductPage: {
  selectDesign: 'Vælg, hvilket produkt du vil lave',
  selectDesignDezeen: 'Samsung X Dezeen', //update
  selectDesignSoccer: 'Samsung X Football', 
  tvConsole: 'TV-bord',
  StorageBox: 'Opbevaringskasse',
  MagazineRack: 'Avishylde',
  CatHouse: 'Kattehus',
  CatTunnel: 'Kattetunnel',
  BookShelf: 'Bogholder',
  DeskShelf: 'Bordordner til skrivebord',
  BlackRhino: 'Udryddelsestruede\n dyr – sort næsehorn', //update
  PolarBear: 'Udryddelsestruede\n dyr – isbjørn', //update
  SeaTurtle: 'Udryddelsestruede\n dyr – skildpadde', //update
  TheRider: 'Gyngehest', //update
  Kibe: 'Trappereolen Kibe', //update
  Tessellate: 'Reol', //update
  Twist: 'Kurven Twist', //update
  AlexCouchArmTable: 'Bord til armlæn', //update
  BlastOffClubHouse: 'Legehus', //update
  KinokoTable: 'Bordet Kinoko', //update
  Magnuss: 'Opbevaringskassen Magnuss', //update
  GIO: 'Krukken Gio', //update
  PostCardPlanter: 'Postkortholder', //update
  SneakerRack: 'Skohylde', //update
  TheSoban: 'Kogebogsholder', //update
  ToolBox: 'Værktøjskasse', //update
  DeskStationary: 'Skrivebordsordner',
  CoinBank: 'Sparegris',
  MobileScanner:'Stativ til skanning med mobil',
  TabletScanner:'Stativ til skanning med tablet',
  PetStairs:'kæledyr trapper',
  PetFurniture:'Pet Friendly Furniture',
  ShoeRackA:'Shoe Rack_A',
  ShoeRackB:'Shoe Rack_B',
  WineRackDog:'Wine Rack Dog',
  WineRack:'Wine Rack',
  mins: 'minutter',
  all:'Alle ',
  in: 'i',
  inOnly: 'i kun',
  allBoxSize: 'Alle kassestørrelser',
  soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
},
DetailGuidePage: {
  1:'1',
  2:'2',
  3:'3',
  instructions: 'instruktioner',
  prepare: 'Forbered emballagen',
  LetsDesign: "Lad os komme i gang med at designe",
  drawParts: 'Tegn delene på emballagen',
  note1: 'Bemærk, at den grafiske position kan variere afhængigt af land og størrelse',
  note2: 'Tegn hele tegningen først, så du ved, at den kan være på emballagen',
  numberSpace: 'tal = afstand mellem prikker',
  diagonal: 'diagonal',
  LEFT: 'VENSTRE',
  RIGHT: 'HØJRE',
  TOP: 'TOP',
  TOP1: 'TOP 1',
  TOP2: 'TOP 2',
  BACK: 'BAGSIDE',
  MIDDLE: 'MIDTE',
  MIDDLE2: 'MIDTE 2',
  BOTTOM: 'BUND',
  FRONT: 'FORSIDE',
  SIDE: 'SIDE',
  secondSIDE: 'ANDEN SIDE',
  secondSIDE1: 'ANDEN SIDE 1',
  secondSIDE2: 'ANDEN SIDE 2',
  LEG: 'BEN', //update
  JOINT: 'SAMLING', //update
  FACE: 'ANSIGT', //update
  DRAWERBOTTOM: 'KASSENS BUND', //update
  DRAWERSIDE: 'KASSENS SIDE', //update
  NOSE: 'NÆSE', //update
  HANDLE: 'HÅNDTAG', //update
  BOTTOMSIDE: 'UNDERSIDE', //update
  TOPSIDE: 'OVERSIDE', //update
  WING: 'VINGE', //update
  cutAndAssemble: "Nu skal du klippe delene ud og samle dem",
  beCareful: 'Vær forsigtig, så du ikke skærer dig, når du klipper',
  cutOutParts: 'Klip delene ud',
  assemble: 'Saml delene',
  Assemblyguide: 'Samlevejledning', //update
  fold: 'Eksempel på foldning',
  foldGuide: 'Brug produktets kant, når du folder pappet',
  foldGuideDezeen:
    'Tryk ned nogle gange på den prikkede linje på emballagen for at gøre det nemmere at folde emballagen', //update
  glue: 'Fordel lim eller tape jævnt på området', //update
  cable: 'Delene kan f.eks. holdes sammen med snor', //update
  done: 'Færdig!',
  goBack: 'Tilbage til hovedmenuen',
},
CautionPage: {
  CAUTION: 'ADVARSEL',
  needItem: 'Du skal bruge følgende genstande',
  children: 'Børn skal være under opsyn af voksne',
  mat:
    'Anbring et underlag på gulvet for at forhindre ridser',
  doNotPutHeavyThing:
    'Man må ikke stå eller sidde på disse møbler, og der må ikke anbringes tunge genstande på dem',
  doNotThrow:
    'Møblerne må ikke kastes eller sparkes mod noget eller nogen, herunder mennesker og dyr',
  stayAwayFlame: 'Holdes væk fra flammer og ild',
  stayAwayWater: 'Holdes væk fra vand og fugt',
  mayDamaged: '*) TV-emballagen kan blive beskadiget under transporten',
  companyDoestResponsible:
    '*) Virksomheden påtager sig intet ansvar for uheld eller skader under dette arbejde',
  cannotBeReturned:
    '*) Produkter, hvis emballage er blevet beskadiget, kan ikke returneres af denne årsag',
  understand: 'OK, det forstår jeg',
},
PrivacyPolicy: {
  title: 'Databeskyttelsespolitik',
},
GoingGreen: {
  visual: {
    title: 'Vores innovationer inden for emballage',
    text1:
      'Vi tilstræber at bruge mindre papir og farve til de fleste af vores TV-emballager sammenlignet med vores tidligere emballager. ',
    text2:'',
    text2_special:
      '(*) Det ovenstående gælder ikke for visse modeller, bl.a. Lifestyle TV)',
    text3: 'Tryk på knappen herunder for at få flere oplysninger',
  },
  greenIn: {
    title: 'Nye emballageinnovationer',
    subtitle1: 'Søg produktinformation',
    subtitle2: 'Upcycling af emballage',
    desc: 'Søg på modelnavn for at læse mere',
    descM: "*) Tag et foto af TV'ets modelnummer",
    guide: 'modelnavn',
    button: 'Tag et foto',
    button2: 'Gå til Lav produkter',
    product_info: 'Produktinformation',
  },
  search: {
    guide: 'Søg ...',
    noResult: 'Ingen resultater',
    more: 'MERE',
    search: 'Søg ',
    retake: 'Prøv igen',
    result: 'Resultat',
  },
  photo: {
    guide1: 'Skriv TV-modelnavnet i feltet',
    guide2: '(f.eks. Q800A, UT7000, RU710)',
  },
},
searchCountrySelect: 'Vælg land for at søge'
};
